// src/components/DeleteOptionsDialog.js

import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { auth } from '../config/firebase';

const DeleteOptionsDialog = ({ open, onClose, onDeleteForMe, onDeleteForEveryone, message }) => {
  
  const canDeleteForEveryone = message?.senderId === auth.currentUser?.uid;

  const handleConfirmDeleteForEveryone = () => {
    console.log("CONFIRM: 'Delete for Everyone' clicked for message:", message);
    onDeleteForEveryone(message);
  };

  const handleConfirmDeleteForMe = () => {
    console.log("CONFIRM: 'Delete for Me' clicked for message:", message);
    onDeleteForMe(message);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Delete Message?</DialogTitle>
      <DialogContent>
        {/* Content can be added here in the future if needed */}
      </DialogContent>
      <DialogActions sx={{ flexDirection: 'column', alignItems: 'flex-end', p: 2, pt: 0 }}>
        <Button
          fullWidth
          variant="text"
          color="error"
          onClick={handleConfirmDeleteForEveryone}
          disabled={!canDeleteForEveryone}
          sx={{ justifyContent: 'flex-end', mb: 1 }}
        >
          Delete for everyone
        </Button>
        <Button
          fullWidth
          variant="text"
          color="error"
          onClick={handleConfirmDeleteForMe}
          sx={{ justifyContent: 'flex-end', mb: 1 }}
        >
          Delete for me
        </Button>
        <Button
          fullWidth
          variant="text"
          onClick={onClose}
          sx={{ justifyContent: 'flex-end' }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteOptionsDialog;